<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <div>
      <label class="required">{{ $t('saleContract.customer') }}</label>
      <div class="ts-flex ts-items-center">
        <!-- <a-select
          v-model="model.customer_id"
          :filterOption="
            (input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
          "
          showSearch
          :options="customerList"
          @change="onCustomerChange"
          class="ts-w-full"
        ></a-select> -->
        <a-select
          show-search
          v-model="model.customer_id"
          style="width: 100%"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          :placeholder="$t('saleContract.typeToSearch')"
          :loading="fetching_customer"
          @search="onCustomerSearch"
          @change="onCustomerChange"
          :options="customerList"
        >
        </a-select>
        <a
          href="#"
          @click.prevent="() => (add_new_customer = true)"
          v-tooltip="$t('add_new')"
          class="ts-bg-blue-500 ts-h-8 ts-w-8 ts-text-white ts-flex ts-items-center ts-rounded-tr ts-rounded-br hover:ts-text-white"
          ><i class="fas fa-plus-square ts-mx-auto"></i
        ></a>
      </div>
      <div class="validate" v-if="errors.has('customer_id')">
        {{ errors.first('customer_id') }}
      </div>
    </div>
    <div class="ts-flex ts-space-x-3 ts-whitespace-no-wrap">
      <p>
        {{ $t('saleContract.creditAmount') }}:
        <span class="ts-ml-3 ts-text-red-600">{{
          creditAmount ? $defaultCurrencyWithCode(creditAmount) : 0
        }}</span>
      </p>
      <p class="ts-mb-0 ts-flex">
        {{ $t('saleContract.creditDay') }}:
        <input
          v-model.number="model.credit_day"
          @input="creditDayChange"
          type="number"
          class="ts-ml-3 ts-p-1 ts-outline-none ts-w-full ts-rounded"
        />
      </p>
    </div>
    <!-- add customer -->
    <a-drawer
      v-if="add_new_customer"
      :title="$t('wholesale.createNewCustomer')"
      :width="400"
      :zIndex="1020"
      :visible="add_new_customer"
      :body-style="{ paddingBottom: '80px' }"
      :maskClosable="false"
      @close="() => (add_new_customer = false)"
    >
      <AddNewCustomer
        @cancel="onCancel"
        @data="setCustomer"
        @close="() => (add_new_customer = false)"
      />
    </a-drawer>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'
import AddNewCustomer from './add-new-customer.vue'

export default {
  name: 'customerSelectBox',
  props: ['value', 'validate'],
  components: {
    AddNewCustomer
  },
  data () {
    return {
      errors: new Errors(),
      add_new_customer: false,
      fetching_customer: false,
      model: {}
    }
  },
  mounted () {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/saleContract', ['customers', 'formViewData']),
    customerList () {
      if (!this.formViewData.customer) return []
      return this.formViewData.customer.map(el => ({
        value: el.customer_id,
        label: el.ss_id_card
          ? el.ss_id_card +
            '|' +
            el.customer_name +
            (el.contact_number ? '|' + el.contact_number : '')
          : el.customer_name +
            (el.contact_number ? '|' + el.contact_number : ''),
        credit_amount: el.credit_amount,
        credit_day: el.credit_day,
        employee_id: el.employee_id
      }))
    },
    creditAmount () {
      if (!this.formViewData.customer) return 0
      let cus = this.formViewData.customer.find(
        c => c.customer_id == this.model.customer_id
      )
      if (cus) {
        return cus.credit_amount
      }
      return 0
    }
  },
  methods: {
    ...mapActions('wholesale/saleContract', [
      'getCustomer',
      'getFormViewData',
      'getSale'
    ]),
    onCustomerSearch: debounce(function (value) {
      this.fetching_customer = true
      this.getFormViewData({
        index: 'customer',
        params: {
          fnName: 'customer',
          customer_search: value
        }
      }).finally(() => (this.fetching_customer = false))
    }, 500),
    onCustomerChange (value, opt) {
      this.model.credit_day = opt.data.props.credit_day
      this.creditDayChange()
      this.model.seller_id = opt.data.props.employee_id
      this.getSale(opt.data.props.employee_id)
    },
    creditDayChange () {
      this.model.payment_expiry_date = moment()
        .add(this.model.credit_day, 'd')
        .format('DD-MM-YYYY')
    },
    onCancel () {
      this.add_new_customer = false
    },
    setCustomer (data) {
      this.$store.commit('wholesale/saleContract/PUSH_NEW_CUSTOMER', data)
      this.model.customer_id = data.customer_id
      this.creditDayChange()
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
